module.exports = __webpack_public_path__ + "media/assets/images/blog/conversational_intelligence-small-0244d3dd6d298de9a0e144be432fe116.jpeg";